import React, { useMemo, useState } from "react";
import { Tabs } from "@amzn/awsui-components-react";
import { useLocation } from "react-router-dom";
import ServiceCollection from "src/services/ServiceCollection";
import CLIReportingConfigMapping from "./MappingsTab";
import AuditHistoryTab from "./AuditHistoryTab";

/** Main view for Tested Party Mapping with Mappings and Audit History tabs. */
export default function TestedPartyMappingView(props: { services: ServiceCollection }) {
    const { search } = useLocation();
    const preSelectedCli = useMemo(() => new URLSearchParams(search).get("cli") ?? undefined, [search]);
    const [activeTabId, setActiveTabId] = useState("mappings");

    return (
        <Tabs
            onChange={({ detail }) => setActiveTabId(detail.activeTabId)}
            activeTabId={activeTabId}
            tabs={[
                {
                    label: "Mappings",
                    id: "mappings",
                    content: activeTabId === "mappings"
                        ? <CLIReportingConfigMapping services={props.services} preSelectedCli={preSelectedCli} />
                        : null,
                },
                {
                    label: "Audit History",
                    id: "auditHistory",
                    content: activeTabId === "auditHistory"
                        ? <AuditHistoryTab services={props.services} />
                        : null,
                },
            ]}
        />
    );
}
